<template>
  <div class="card shadow bg-white dark:bg-gray-800 rounded-md p-5 border dark:border-gray-700 flex flex-col justify-between">
    <div class="flex items-center">
      <Icon :icon="icon" width="20" />
      <p class="ml-2 mt-1 text-gray-900 dark:text-gray-200 text-base">
        {{ title }}
      </p>
      <ToolTip v-if="tooltipText !== ''" class="absolute" style="right:4px; top:7px">
        <h2 v-if="tooltipTitle !== ''" class="card-title">{{ tooltipTitle }}</h2>
        <p>{{ tooltipText }}</p>
      </ToolTip>
    </div>
    <h1 class="mt-4 text-bold text-right" :class="valueClass" style="font-size: 24px;">
      <span v-if="displayText !== ''">{{ displayText }}</span>
      <span v-else>{{ animatedValue.toFixed(value % 1 === 0 ? 0 : 1) }}{{ unit }}</span>
    </h1>
  </div>
</template>

<script setup>
import { ref, watch, onUnmounted, defineProps } from 'vue';
import { Icon } from '@iconify/vue/dist/offline';
import ToolTip from './Tooltip.vue'; 

const props = defineProps({
  title: { type: String, required: true },
  value: { type: Number, required: true },
  icon: { type: String, required: true },
  unit: { type: String, default: '' },
  valueClass: { type: String, default: 'text-gray-700 dark:text-gray-300' },
  tooltipTitle: { type: String, default: '' },
  tooltipText: { type: String, default: '' },
  duration: { type: Number, default: 1000 },
  displayText: { type: String, default: '' }
});

const animatedValue = ref(0);
let animationInterval = null;

const animateValue = (startValue, endValue) => {
  if (animationInterval !== null) {
    clearInterval(animationInterval);
  }

  if (startValue === endValue) {
    animatedValue.value = endValue;
    return;
  }

  const range = endValue - startValue;
  const increment = endValue > startValue ? 1 : -1;
  const stepTime = Math.abs(Math.floor(props.duration / range));
  let current = startValue;
  const timerStep = Math.max(1, stepTime); 
  
  let startTime = null;

  function step(timestamp) {
    if (startTime === null) startTime = timestamp;
    const elapsed = timestamp - startTime;
    const progress = Math.min(1, elapsed / props.duration);
    const nextValue = startValue + range * progress;

    animatedValue.value = nextValue;

    if (progress < 1) {
        animationInterval = requestAnimationFrame(step);
    } else {
        animatedValue.value = endValue; 
    }
  }
  animationInterval = requestAnimationFrame(step);


};

watch(() => props.value, (newValue, oldValue) => {
  animateValue(animatedValue.value, newValue); 
}, { immediate: true }); 

onUnmounted(() => {
  if (animationInterval !== null) {
     cancelAnimationFrame(animationInterval);
  }
});
</script>

<style scoped>

</style> 